import z from "zod";
export var PreAnnotateModelTypeEnum;
(function (PreAnnotateModelTypeEnum) {
    PreAnnotateModelTypeEnum["SEGMENTATION"] = "segmentation";
    PreAnnotateModelTypeEnum["DETECTION"] = "detection";
})(PreAnnotateModelTypeEnum || (PreAnnotateModelTypeEnum = {}));
export var PreAnnotateProviderEnum;
(function (PreAnnotateProviderEnum) {
    PreAnnotateProviderEnum["TRAINED_MODEL"] = "trained_model";
    PreAnnotateProviderEnum["SAM3"] = "sam3";
    PreAnnotateProviderEnum["ROBOPIPE_VISION"] = "robopipe_vision";
})(PreAnnotateProviderEnum || (PreAnnotateProviderEnum = {}));
export const RETIRED_PROVIDER_LLM_SAM3 = "llm_sam3";
export const preAnnotateEngineSchema = z.enum([
    PreAnnotateProviderEnum.ROBOPIPE_VISION,
]);
export const LABEL_DESCRIPTION_MAX = 500;
export const labelDescriptionSchema = z.string().trim().max(LABEL_DESCRIPTION_MAX);
export const labelDescriptionsSchema = z.record(z.string().regex(/^\d+$/, "keys must be label ids"), labelDescriptionSchema);
export const preAnnotateConfigSchema = z.object({
    provider: preAnnotateEngineSchema,
    defaultMode: z.enum(PreAnnotateModelTypeEnum),
    referenceTaskId: z.number().int().positive().nullable(),
});
export const preAnnotateAvailabilitySchema = z.object({
    visionAvailable: z.boolean(),
});
export const preAnnotateSettingsDocumentSchema = z.object({
    config: preAnnotateConfigSchema,
    labelDescriptions: labelDescriptionsSchema,
    availability: preAnnotateAvailabilitySchema,
});
export const updatePreAnnotateSettingsDocumentSchema = z.object({
    config: preAnnotateConfigSchema,
    labelDescriptions: labelDescriptionsSchema.optional(),
});
export const hasUsableDescriptions = (descriptions) => descriptions != null &&
    Object.values(descriptions).some((d) => d.trim().length > 0);
//# sourceMappingURL=preAnnotateSettings.schema.js.map